import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Card, Modal } from 'sa-ui';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { Popover, OverlayTrigger, Button } from 'react-bootstrap';

import * as helpers from './reportHelpers';

import './HitPerformancePerAbility.scss';

import messages from './hitPerformancePerAbilityMessages';
import LoadMore from './LoadMore';

const HitPerformancePerAbility = (props) => {
  const [limit, setLimit] = useState(props.limit);

  console.log('props', props);

  return (
    <div className="card">
      <div className="card-body">
        <div className="card-title mb-3">
          <i className="pe-7s-graph1 mr-2" />
          {props.intl.formatMessage(messages.title)}
        </div>
        <table className="default-table">
          <thead className="text-center">
            <tr>
              <th>{props.intl.formatMessage(messages.question)}</th>
              <th>{props.intl.formatMessage(messages.ability)}</th>
              <th>{props.intl.formatMessage(messages.curriculumComponent)}</th>
              <th>{props.intl.formatMessage(messages.hitPercentage)}</th>
            </tr>
          </thead>
          <tbody>
            {props.items.slice(0, limit).map((item, index) => (
              <tr className="text-center">
                <td
                  className={`align-middle ${
                    item.answerHit !== '-' ? (item.answerHit ? 'text-success' : 'text-danger') : ''
                  }`}
                  style={item.canceled ? { textDecoration: 'line-through' } : {}}
                >
                  {item.position}
                  {item.answerHit !== '-' ? (
                    item.answerHit ? (
                      <i className="pe-7s-check large" />
                    ) : (
                      <i className="pe-7s-close-circle large" />
                    )
                  ) : (
                    ''
                  )}
                </td>
                <td className="align-middle btn-abilities">
                  {item.abilityName ? (
                    <OverlayTrigger
                      trigger="hover"
                      key={index}
                      placement="left"
                      overlay={
                        <Popover id="popover-positioned-left">
                          <Popover.Body>{item.abilityDescription}</Popover.Body>
                        </Popover>
                      }
                    >
                      <Button style={item.canceled ? { textDecoration: 'line-through' } : {}}>
                        {item.abilityName}
                      </Button>
                    </OverlayTrigger>
                  ) : (
                    '-'
                  )}
                </td>
                <td
                  className="align-middle"
                  style={item.canceled ? { textDecoration: 'line-through' } : {}}
                >
                  {item.curricularComponent}
                </td>
                <td className="align-middle pb-0 pt-1">
                  <div className="scale scale-medium d-inline-block">
                    <div
                      className="scale-step step-85"
                      style={
                        item.canceled
                          ? { backgroundColor: '#555555' }
                          : { backgroundColor: helpers.getColor(item.percentHitsAbility) }
                      }
                    >
                      <div className="content">{`${item.percentHitsAbility}%`}</div>
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {props.items && props.items.length > 10 ? (
          <LoadMore onClick={() => setLimit(limit + props.limit)} />
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

HitPerformancePerAbility.defaultProps = {
  limit: 10,
};

export default injectIntl(HitPerformancePerAbility);
